import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  IconButton,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { DIALOG_CONTEXT } from '../utils';
import InfoContent from './InfoContent';
import CreateContent from './CreateContent';
import EditContent from './EditContent';
import DeleteContent from './DeleteContent';

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    padding: 40,
    maxWidth: 742,
    borderRadius: '12px',
    fontFamily: 'Suisse-Intl',
    position: 'absolute',
    marginTop: '0px',
    top: '95px',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(149, 152, 154, 0.43)',
      borderRadius: 5,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(149, 152, 154, 1)',
    },
  },
});

const MatchmakingDialog = ({ data }) => {
  if (!data.isOpen) return null;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  // Functions
  const handleOverflowBody = () => {
    const bodyStatus = document.body.getAttribute('style');
    if (bodyStatus.includes('overflow: hidden')) {
      document.body.style.overflow = 'visible';
      document.body.style.paddingTop = 79;
    }
  };

  const handleClose = () => {
    handleOverflowBody();
    data?.onClose();
  };

  const handleAgree = () => {
    handleOverflowBody();
    data?.onAgree();
  };

  const onSubmitData = (submittedData) => {
    handleOverflowBody();
    data?.onAgree(submittedData);
  };

  const renderContent = () => {
    switch (data.context) {
      case DIALOG_CONTEXT.INFO:
        return (
          <InfoContent
            onClose={handleClose}
            onAgree={handleAgree}
            askFor={data.askFor}
          />
        );
      case DIALOG_CONTEXT.CREATE:
        return (
          <CreateContent onClose={handleClose} onCreateSubmit={onSubmitData} />
        );
      case DIALOG_CONTEXT.EDIT:
        return (
          <EditContent
            onClose={handleClose}
            onEditPasswordSubmit={onSubmitData}
            userName={data.userName}
          />
        );
      case DIALOG_CONTEXT.DELETE:
        return <DeleteContent onClose={handleClose} onAgree={handleAgree} />;
      default:
        return <div>Something went wrong:: No context here!</div>;
    }
  };

  return (
    <StyledDialog open={data.isOpen} onClose={handleClose}>
      <div
        tabIndex={0}
        role="button"
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: 20,
          right: 30,
        }}
      >
        <StyledIconButton>
          <CloseIcon fontSize={isSmDown ? 'small' : 'medium'} />
        </StyledIconButton>
      </div>
      {renderContent()}
    </StyledDialog>
  );
};

export default MatchmakingDialog;
